import React, { useState } from "react";
import styles from "./styles.module.css";
import { InputProps } from "../types";
import { Spacing } from "spacing/component";
import { TextCaption } from "fonts/Caption";

import { classNames } from "helpers/string";
import showPasswordImgSrc from "../../../assets/31-visibility-m.svg";

export const TextInput = ({
  error,
  placeholder,
  disabled,
  type,
  autoFocus,
  value = "",
  onChange
}: InputProps) => {
  const [inputType, setInputType] = useState(type);

  return (
    <React.Fragment>
      <div className={styles.container}>
        <input
          className={classNames(styles, { error })}
          type={inputType}
          onChange={onChange && (evt => onChange(evt.target.value))}
          {...{ disabled, value, placeholder, autoFocus }}
        />
        {type === "password" && (
          <Spacing
            ph="s"
            pv="xs"
            className={styles.showPasswordIcon}
            onClick={() =>
              setInputType(inputType === "password" ? "text" : "password")
            }
          >
            <img src={showPasswordImgSrc} />
          </Spacing>
        )}
      </div>
      {error && (
        <React.Fragment>
          <Spacing pt="5xs" />
          <TextCaption className={styles.redColor}>{error}</TextCaption>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
